import { render, staticRenderFns } from "./TableHistoricoRelacionamento.vue?vue&type=template&id=26e70b0e&scoped=true&"
import script from "./TableHistoricoRelacionamento.vue?vue&type=script&lang=js&"
export * from "./TableHistoricoRelacionamento.vue?vue&type=script&lang=js&"
import style0 from "./TableHistoricoRelacionamento.vue?vue&type=style&index=0&id=26e70b0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e70b0e",
  null
  
)

export default component.exports